import React, { useState } from 'react';

const SearchableSelect = ({ label, name, value, onChange, options, placeholder, required, style }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  
  const selectedOption = options.find(o => o.value === value);
  const filteredOptions = options.filter(o => 
    o.label.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div style={{ position: 'relative', ...style }}>
      {label && (
        <label style={{ display: 'block', marginBottom: '0.4rem', fontSize: '0.8125rem', fontWeight: 600 }}>
          {label} {required && '*'}
        </label>
      )}
      <div 
        onClick={() => setIsOpen(!isOpen)}
        className="input-select-trigger"
        style={{
          padding: '0.55rem 0.75rem',
          border: '1px solid var(--border-light)',
          borderRadius: 'var(--radius-md)',
          backgroundColor: 'var(--bg-card, #fff)',
          cursor: 'pointer',
          fontSize: '0.875rem',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          minHeight: '38px'
        }}
      >
        <span style={{ color: selectedOption ? 'var(--text-primary)' : 'var(--text-muted)' }}>
          {selectedOption ? selectedOption.label : placeholder}
        </span>
        <span style={{ fontSize: '0.6rem', opacity: 0.5 }}>▼</span>
      </div>

      {isOpen && (
        <>
          <div 
            style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, zIndex: 999 }} 
            onClick={() => setIsOpen(false)}
          />
          <div style={{
            position: 'absolute',
            top: '100%',
            left: 0,
            right: 0,
            zIndex: 1000,
            backgroundColor: 'var(--bg-card, #fff)',
            border: '1px solid var(--border-light)',
            borderRadius: 'var(--radius-md)',
            marginTop: '0.25rem',
            boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
            maxHeight: '300px',
            display: 'flex',
            flexDirection: 'column'
          }}>
            <div style={{ padding: '0.5rem', borderBottom: '1px solid var(--border-light)' }}>
              <input 
                type="text" 
                autoFocus
                placeholder="Search..." 
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                onClick={(e) => e.stopPropagation()}
                style={{
                  width: '100%',
                  padding: '0.4rem',
                  border: '1px solid var(--border-light)',
                  borderRadius: 'var(--radius-sm)',
                  fontSize: '0.8125rem',
                  outline: 'none'
                }}
              />
            </div>
            <div style={{ overflowY: 'auto' }}>
              {filteredOptions.length === 0 ? (
                <div style={{ padding: '0.75rem', fontSize: '0.8125rem', color: 'var(--text-muted)', textAlign: 'center' }}>
                  No results found
                </div>
              ) : filteredOptions.map(o => (
                <div 
                  key={o.value}
                  onClick={() => {
                    onChange({ target: { name, value: o.value } });
                    setIsOpen(false);
                    setSearchTerm('');
                  }}
                  style={{
                    padding: '0.625rem 0.75rem',
                    fontSize: '0.8125rem',
                    cursor: 'pointer',
                    backgroundColor: value === o.value ? 'rgba(var(--primary-rgb), 0.1)' : 'transparent',
                    color: value === o.value ? 'var(--primary)' : 'var(--text-primary)',
                    borderBottom: '1px solid var(--border-light)'
                  }}
                  onMouseOver={(e) => e.currentTarget.style.backgroundColor = 'var(--bg-soft)'}
                  onMouseOut={(e) => e.currentTarget.style.backgroundColor = value === o.value ? 'rgba(var(--primary-rgb), 0.1)' : 'transparent'}
                >
                  {o.label}
                </div>
              ))}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default SearchableSelect;
